(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["footer-column"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('footer-column')) {
    class FooterColumn extends HTMLElement {
      connectedCallback() {
        this.toggleButton = this.querySelector('[data-ref="toggle"]');
        this.mediaQuery = window.matchMedia('(max-width: 750px)');
        this.firstSync = true;

        this.onMediaChange = () => this.sync();
        this.onToggle = () => this.setOpen(!this.classList.contains('is-open'));
        this.onBlockSelect = (event) => {
          if (this.classList.contains('is-collapsible') && this.contains(event.target)) this.setOpen(true);
        };

        this.mediaQuery.addEventListener('change', this.onMediaChange);
        this.toggleButton.addEventListener('click', this.onToggle);
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.sync();
      }

      disconnectedCallback() {
        this.mediaQuery.removeEventListener('change', this.onMediaChange);
        this.toggleButton.removeEventListener('click', this.onToggle);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      sync() {
        const isMobile = this.mediaQuery.matches;
        this.classList.toggle('is-collapsible', isMobile);

        if (isMobile) {
          const startOpen = this.firstSync && this.hasAttribute('data-open-on-mobile');
          this.setOpen(startOpen || this.classList.contains('is-open'));
        } else {
          this.classList.remove('is-open');
          this.toggleButton.setAttribute('aria-expanded', 'false');
        }

        this.firstSync = false;
      }

      setOpen(open) {
        this.classList.toggle('is-open', open);
        this.toggleButton.setAttribute('aria-expanded', String(open));
      }
    }

    customElements.define('footer-column', FooterColumn);
  }
  } catch(e) { console.error(e); }
})();

})();
